const action = {
    LOG_LIST_READ: 'LOG_LIST_READ',
    LOG_LIST_READ_SUCCESS: 'LOG_LIST_READ_SUCCESS',
   
  logRead:(readFilter, page) => ({ 
    type: action.LOG_LIST_READ,
    payload: { readFilter,page } 
  }),
  logReadSearchSuccess: (data, success, totalCount) => ({
    type: action.LOG_LIST_READ_SUCCESS,
    data,
    success,
    totalCount,
   
  }),
  };
  export default action;